//
//
//
//
//
//

import { controlTopButton } from '@/util/const'

export default {
  created () {
    controlTopButton({
      backVisible: false,
      right1icon: 'btn_ol_close',
      right1link: 'cmcchkh5action://close'
    })
  }
}



// WEBPACK FOOTER //
// ./src/page/concert/invalidPage.vue